import { render, staticRenderFns } from "./HerbariumGrid.vue?vue&type=template&id=14da6039&scoped=true&"
import script from "./HerbariumGrid.vue?vue&type=script&lang=js&"
export * from "./HerbariumGrid.vue?vue&type=script&lang=js&"
import style0 from "./HerbariumGrid.vue?vue&type=style&index=0&id=14da6039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da6039",
  null
  
)

export default component.exports